<template>
  <div class="text-left">
    <div class="d-flex py-4">
      <div class="align-self-center">
        <v-select
            :items="Object.values(pestTypesEnum)"
            label="añadir nuevo"
            v-model="selectedPesticideType"
        ></v-select>
      </div>
      <v-btn
          color="primary lighten-2"
          text
          :disabled="!selectedPesticideType"
          @click="addNewPestRecord(selectedPesticideType)"
      >
        añadir nuevo
      </v-btn>

    </div>

    <div
        v-for="(pesticideSection, index) in pesticidesSections"
    >
      <p class="subtitle-2 ma-auto pa-0">{{ pesticideSection.pesticideType | capitalize }}</p>
      <PesticideInput
          :pesticideFormData="pesticideSection.autocompleteData"
          v-model="pesticideSection.formField"
          @deleteFormField="deletePesticideSection(index)"
      />

    </div>

  </div>
</template>

<script>
import {parseToPesticideFormData} from "@/views/partners/hr_co/utils";
import {
  pestAndMitesPesticidesData
} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/pestAndMitesPesticidesData";
import {pesticidesData} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/fungicides";
import pestTypesMixin from "@/views/partners/hr_co/components/pestsAndDiseasesInput/pestTypesMixin";
import {insecticidesData} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/insecticidesData";
import {fungicidesData} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/fungicidesData";
import {bactericidesData} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/bactericidesData";
import {weedsData} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/data/weedsData";
import PesticideInput from "@/views/partners/hr_co/components/pestsAndDiseasesInput/PesticideInput";
import {pestAndMitesPesticides} from "@/views/partners/hr_co/components/pestsAndDiseasesInput/pestAndMitesPesticides";

export default {
  props: ['value'],
  components: {
    PesticideInput
  },
  data() {
    // todo trim the pesticides
    return {
      selectedPesticideType: null,
      pesticideFormData: parseToPesticideFormData(pesticidesData),
      pesticidesAutocompleteData: parseToPesticideFormData(pestAndMitesPesticidesData), // todo remove
      pesticidesSections: []
    }
  },
  methods: {
    pestAutocompleteSelect(value, index) {
      this.selectedPestsSearch = value.pesticides
      this.selectedPest = value
    },
    addNewPestRecord(pesticideType) {
      this.pesticidesSections.push(this.newPestRecord(pesticideType))
    },
    newPestRecord(pesticideType) {
      // autocompleteData:  this.pesticidesAutocompleteData
      // todo check if pest type add correct autocomplete, formField
      const newPestSection = {
        pesticideType,
        formField: {
          pest: {
            question: '',
            answer: undefined
          },
          pesticide: {
            question: '',
            answer: undefined
          },
          pesticideFrequency: {
            question: '',
            answer: undefined
          }
        },
      }

      // todo here
      if (pesticideType === this.pestTypesEnum.insecticides) {
        console.log('insecticides', pesticideType)
        newPestSection.autocompleteData = this.insecticidesAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.fungicides) {
        console.log('fungicides', pesticideType)
        newPestSection.autocompleteData = this.fungicidesAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.bactericides) {
        console.log('bactericides', pesticideType)
        newPestSection.autocompleteData = this.bactericidesAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.weeds) {
        console.log('weeds', pesticideType)
        newPestSection.autocompleteData = this.weedsAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.bioInputs) {
        console.log('bioInputs', pesticideType)
        newPestSection.autocompleteData = this.bioInputsAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.compostAndAmendments) {
        console.log('compostAndAmendments', pesticideType)
        newPestSection.autocompleteData = this.compostAndAmendmentsAutocompleteData
      }

      if (pesticideType === this.pestTypesEnum.fertilizers) {
        console.log('fertilizers', pesticideType)
        newPestSection.autocompleteData = this.fertilizersAutocompleteData
      }

      return newPestSection
    },

    // deleteFormField(index) {
    //   this.pesticideFormFields.splice(index, 1)
    // },
    deletePesticideSection(index) {
      console.log('pesticidesSections', index)
      this.pesticidesSections.splice(index, 1)
    },
    validate() {
      console.log('PesticideListInput.validate')
      for (let i = 0; i < pestAndMitesPesticides.length; i++) {
        this.$refs[`form${i}`][0].validate();
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(to) {
        if (!to) {
        } else {
          this.pesticidesSections = to;
        }
      }
    },
    pesticidesSections:{
      deep: true,
      handler(to) {
        console.log('pesticidesSections', to)
        this.$emit('input', to);
      },
    },
  },
  mixins: [pestTypesMixin]
}

</script>

<style scoped>

</style>